import { Layout, NavDrawer, Panel } from '@luminopia/react-toolbox/lib/layout'
import Navigation from '@luminopia/react-toolbox/lib/navigation'
import AppBar from 'core/components/AppBar'
import {ActivityLink} from 'core/components/link'
import NavigationItem, {ITheme as INavigationItemTheme} from 'core/components/NavigationItem'
import * as React from 'react'
import { connect, Dispatch } from 'react-redux'
import {Route, RouteComponentProps, RouteProps} from 'react-router'
import { IState, getReviewerRequest } from 'study_reviewer/store'
import * as routes from '../../routes'
import * as appBarTheme from './appBarTheme.css'
import * as classNames from './dashboard.css'
import { IReviewer } from 'study_reviewer/store/reviewers/model'
import * as Pages from '../../pages'

// TODO: react-toolbox type definition for NavDrawer is missing the base props,
// so we can't specify className on it. This works for now until that type def is fixed
const navDrawerTheme = {pinned: classNames.navDrawer, clipped: classNames.navDrawer}

interface IStateProps {
  role: string
  currentReviewer: IReviewer | null
}

interface IDispatchProps {
  onMount?: () => void;
}

const mapStateToProps = (state: IState): IStateProps => {
  return {
    role: state.login.role,
    currentReviewer: state.reviewers.currentReviewer
  }
}

const mapDispatchToProps = (dispatch: Dispatch<void>) => ({
  onMount: () => {
    dispatch(getReviewerRequest())
  },
});

interface IOwnProps extends RouteComponentProps<void> {}

interface IProps extends IDispatchProps, IOwnProps {}

class Dashboard extends React.PureComponent<IProps & IStateProps, {}> {
  public render() {
    const isAdmin = this.props.role === 'studyAdmin'
    const navigationItemTheme: INavigationItemTheme = {
      container: classNames.itemContainer,
      containerActive: classNames.itemContainerActive,
      iconContainer: classNames.itemIconContainer,
      labelContainer: classNames.itemLabelContainer,
      label: classNames.itemLabel,
    }

    return (
      <Layout>
        <AppBar theme={appBarTheme}/>
        <NavDrawer pinned theme={navDrawerTheme}>
          <Navigation className={classNames.nav} type='vertical'>
          <p className={classNames.statusText}>Adherence Portal | v1.7</p>
            <ActivityLink to={routes.subjectsListRoute()}>
              {(active: boolean) => (
                <NavigationItem
                  icon='groups'
                  label='Active Patients'
                  active={active}
                  theme={navigationItemTheme}
                />
              )}
            </ActivityLink>
            <ActivityLink to={routes.subjectsNotInTreatmentListRoute()}>
              {(active: boolean) => (
                <NavigationItem
                  icon='groups'
                  label='Inactive Patients'
                  active={active}
                  theme={navigationItemTheme}
                />
              )}
            </ActivityLink>
            {isAdmin && (
              <ActivityLink to={routes.physiciansListRoute()}>
              {(active: boolean) => (
                <NavigationItem
                  icon='manage_accounts'
                  label='Manage Physicians'
                  active={active}
                  theme={navigationItemTheme}
                />
              )}
            </ActivityLink>
            )}
            {!isAdmin && this.props.currentReviewer && !this.props.currentReviewer.isTechnician && (
              <ActivityLink to={routes.techniciansListRoute()}>
                {(active: boolean) => (
                  <NavigationItem
                    icon='manage_accounts'
                    label='Manage Technicians'
                    active={active}
                    theme={navigationItemTheme}
                  />
                )}
              </ActivityLink>
            )}
            <ActivityLink to={routes.accountRoute()}>
              {(active: boolean) => (
                <NavigationItem
                  icon='lock'
                  label='My Account'
                  active={active}
                  theme={navigationItemTheme}
                />
              )}
            </ActivityLink>
            <ActivityLink to={routes.logoutRoute()}>
              {(active: boolean) => (
                <NavigationItem
                  icon='exit_to_app'
                  label='Log out'
                  active={active}
                  theme={navigationItemTheme}
                />
              )}
            </ActivityLink>
          </Navigation>
        </NavDrawer>
        {this.props.currentReviewer && (
          <Panel className={classNames.panel}>
            {this.props.currentReviewer.isAdmin && (
              <p className={classNames.greeting}>Hello, Luminopian {this.props.currentReviewer.email}<br/><small>Admin NPI: {this.props.currentReviewer.npi}</small></p>
            )}
            {!this.props.currentReviewer.isAdmin && !this.props.currentReviewer.isTechnician && (
              <p className={classNames.greeting}>Hello, Dr. {this.props.currentReviewer.lastName}<br/><small>NPI: {this.props.currentReviewer.npi}</small></p>
            )}
            {!this.props.currentReviewer.isAdmin && this.props.currentReviewer.isTechnician && (
              <p className={classNames.greeting}>Hello, {this.props.currentReviewer.firstName} {this.props.currentReviewer.lastName}</p>
            )}
            <div className={classNames.contentContainer}>
              <Route exact path={routes.rootRoute()} render={() => <Pages.SubjectsListPage treatmentStatus='ACTIVE' currentReviewer={this.props.currentReviewer} />} />
              <Route exact path={routes.subjectsListRoute()} render={() => <Pages.SubjectsListPage treatmentStatus='ACTIVE' currentReviewer={this.props.currentReviewer} />} />
              <Route exact path={routes.subjectsNotInTreatmentListRoute()} render={() => <Pages.SubjectsListPage treatmentStatus='NOT ACTIVE' currentReviewer={this.props.currentReviewer} />} />
              <Route exact path={routes.physiciansListRoute()} component={Pages.PhysiciansListPage} />
              <Route exact path={routes.techniciansListRoute()} render={(props) => <Pages.TechniciansListPage currentReviewer={this.props.currentReviewer} {...props} />} />
              <Route exact path={routes.subjectShowRoute()} render={(props) => <Pages.SubjectPage currentReviewer={this.props.currentReviewer} {...props} />} />
              <Route exact path={routes.reviewerShowRoute()} component={Pages.PhysiciansPage} />
              <Route exact path={routes.accountRoute()} render={(props) => <Pages.AccountPage currentReviewer={this.props.currentReviewer} {...props} />} />
            </div>
          </Panel>
        )}
      </Layout>
    )
  }

  public componentDidMount() {
    if (this.props.onMount) {
      this.props.onMount();
    }
  }
}
export default connect<IStateProps, IDispatchProps, IOwnProps, IState>(mapStateToProps, mapDispatchToProps)(Dashboard)



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_reviewer/src/components/dashboard/dashboard.tsx